<template>
  <div :class="$style[`addNewShoppingList${displayType}`]">
    <aw-form
      v-model="v$"
      :class="$style.addNewShoppingListInputWrapper"
      @on-submit="addNewBasketList"
    >
      <aw-form-row-version2 ref="nameFormRow" v-model="newShoppingListName" :class="$style.addNewShoppingListInput">
        <template #postfix>
          <button class="buttonReset" @click="closeAddNewShoppingListForm" @focus="v$.$reset()">
            <lv-icon name="delete-16" :size="16" style="vertical-align: unset;" />
          </button>
        </template>
      </aw-form-row-version2>
      <aw-form-button-version2
        v-model="v$"
        styling="small-primary-dark-just-icon"
        loading-id="add-to-saved-basket-modal"
      >
        <lv-icon name="check-circle-version2-16" :size="16" style="vertical-align: unset;" />
      </aw-form-button-version2>
    </aw-form>
  </div>
</template>

<script>
  import AwFormRowVersion2 from '~~/common/components/Form/AwFormRowVersion2';
  import AwForm from '~~/common/components/Form/AwForm';
  import AwFormButtonVersion2 from '~~/common/components/Form/AwFormButtonVersion2';
  import { LvIcon } from '~~/common/components/loginet-vue-shop/index';
  import { useVuelidate } from '@vuelidate/core';
  import { maxLength, minLength, required } from '@vuelidate/validators';
  import { useNuxtApp } from 'nuxt/app';
  import { nextTick } from 'vue';
  import { useUserStore } from '~~/common/stores/user';
  import { useUserInterfaceStore } from '~~/common/stores/userInterface.js';
  import { getErrorNotification } from '~~/common/utils/helper';

  export default {
    name: 'AwAddNewShoppingListForm',
    components: {
      AwFormButtonVersion2,
      AwForm,
      AwFormRowVersion2,
      LvIcon,
    },
    props: {
      displayType: {
        type: String,
        required: true,
        validator: (value) => ['modal', 'tooltip'].includes(value),
      },
    },
    emits: ['close-add-new-shopping-list-form'],
    setup: () => ({ v$: useVuelidate() }),
    validations () {
      return {
        newShoppingListName: {
          model: {
            required,
            maxLength: maxLength(50),
            minLength: minLength(2),
          },
        },
      };
    },
    data () {
      return {
        newShoppingListName: {
          version2: true,
          model: '',
          type: 'text',
          name: 'newShoppingListName',
          label: '',
          labelAttrs: {
            for: 'newShoppingListName',
          },
          widgetAttrs: {
            id: 'newShoppingListName',
          },
          tokens: {
            maxLength: 'aw.common.favourite.validation.max_length',
            minLength: 'aw.common.favourite.validation.min_length',
          },
        },
      };
    },
    methods: {
      showCallback () {
        nextTick(() => {
          this.v$.$reset();
          nextTick(() => {
            this.v$.$reset();
            this.$refs.nameFormRow.$el.querySelector('[data-input-block]').focus();
          });
        });
      },
      closeAddNewShoppingListForm () {
        this.$emit('close-add-new-shopping-list-form');
        this.newShoppingListName.model = '';
        this.v$.$reset();
      },
      async addNewBasketList () {
        const userInterfaceStore = useUserInterfaceStore();

        try {
          userInterfaceStore.startLoading({ id: 'add-to-saved-basket-modal' });
          await this.$api.post('/me/shopping_lists', {
            name: this.newShoppingListName.model,
          });

          this.apiError = false;
          await this.initShoppingListNames();
          this.v$.$reset();
          this.newShoppingListName.model = '';
          this.$emit('close-add-new-shopping-list-form');
        } catch (error) {
          this.apiError = getErrorNotification(useNuxtApp(), error);
        } finally {
          userInterfaceStore.endLoading({ id: 'add-to-saved-basket-modal' });
          nextTick(() => {
            nextTick(() => {
              this.$refs.addNewShoppingListButton.$el.focus();
            });
          });
        }
      },

      async initShoppingListNames () {
        const userStore = useUserStore();
        await userStore.fetchShoppingListNames();
      },
    },
  };
</script>

<style module lang="scss" rel="stylesheet/scss">

.addNewShoppingList {
  &modal {
    .addNewShoppingListInput {
      &Wrapper {
        [data-input-block] {
          padding: 7px;
          border-radius: 8px;
        }
      }
    }
  }

  &tooltip {
    .addNewShoppingListInput {
      &Wrapper {
        margin-top: 10px;
        margin-bottom: 2px;

        [data-input-block] {
          padding: 5px 7px;
        }
      }
    }
  }
}

.addNewShoppingListInput {
  width: calc(100% - 40px);
  margin-bottom: 0 !important;

  &Wrapper {
    display: flex;
    gap: 8px;

    [data-input-wrapper] {
      gap: 8px;
      border-radius: 8px !important;
    }

    [data-input-postfix] {
      height: 16px;
      padding: 0 7px 0 0 !important;
    }

    [data-input-block] {
      font-weight: $font-weight-normal-v2;
    }
  }
}


</style>
